// src/lib/services/global-search-api.service.ts

import {inject, Injectable} from '@angular/core';
import {ICycle, IQueryUsersRequestParams, MinimalUserModel, UserGroup} from '@core/api/data-access';
import {CyclesService} from '@cycles/data-access';
import {UserGroupsStore, UserStore} from '@data-users';
import {AbstractQueryBuilder, ICycleQueryRequest} from '@global-data';
import {map, Observable, of} from 'rxjs';
import {BuilderByCategoryInstance, GlobalSearchCategory, PagedResult, SearchResultItem} from '../types/global-search.types';

@Injectable({
	providedIn: 'root',
})
export class GlobalSearchApiService {
	private readonly cyclesService = inject(CyclesService);
	private readonly userStore = inject(UserStore);
	private readonly userGroupsStore = inject(UserGroupsStore);

	constructor() {}

	public search<C extends GlobalSearchCategory>(category: C, builder: BuilderByCategoryInstance<C>, page: number, size: number): Observable<PagedResult<SearchResultItem<C>>> {
		switch (category) {
			case GlobalSearchCategory.CYCLE:
				return this.searchCycles(builder, page, size) as Observable<PagedResult<SearchResultItem<C>>>;
			case GlobalSearchCategory.USER:
				return this.searchUsers(builder, page, size) as Observable<PagedResult<SearchResultItem<C>>>;
			case GlobalSearchCategory.USER_GROUP:
				return this.searchUserGroups(builder, page, size) as Observable<PagedResult<SearchResultItem<C>>>;
			default:
				throw new Error(`Unknown category: ${category}`);
		}
	}

	// --- Category Specific Search Methods ---

	private searchCycles(builder: AbstractQueryBuilder<any, any>, page: number, size: number): Observable<PagedResult<ICycle>> {
		const params: ICycleQueryRequest = {
			query: builder.build(),
			page,
			size,
		};
		return this.cyclesService.query(params).pipe(
			map(response => {
				const pagedResult: PagedResult<ICycle> = {
					items: response.cycles,
					total: response.totalCycles,
					page: page,
				};
				return pagedResult;
			}),
		);
	}

	private searchUsers(builder: AbstractQueryBuilder<any, any>, page: number, size: number): Observable<PagedResult<MinimalUserModel>> {
		const params: IQueryUsersRequestParams = {
			query: builder.build(),
			page,
			size,
		};
		return this.userStore.queryUsers(params).pipe(
			map(response => {
				const pagedResult: PagedResult<MinimalUserModel> = {
					items: response.users,
					total: response.totalUsers,
					page: page,
				};
				return pagedResult;
			}),
		);
	}

	private searchUserGroups(builder: AbstractQueryBuilder<any, any>, page: number, size: number): Observable<PagedResult<UserGroup>> {
		// const params: IQueryUsersRequestParams = {
		// 	query: builder.build(),
		// 	page,
		// 	size,
		// };
		// return this.userGroupsStore.queryUserGroups(params).pipe(
		// 	map(response => {
		// 		const pagedResult: PagedResult<UserGroup> = {
		// 			items: response,
		// 			total: response.length,
		// 			page: page,
		// 		};
		// 		return pagedResult;
		// 	}),
		// );
		debugger;
		return of({
			items: [],
			total: 0,
			page: 0,
		} as PagedResult<UserGroup>);
	}
}
